export type ProjectAccessMode = 'editable' | 'readOnly' | 'readOnlyTemplate'

type ProjectAccessFields = {
  id: string
  accessMode?: ProjectAccessMode
  isDemoTemplate?: boolean
}

type ProjectApiAccessFields = {
  is_demo_template?: boolean
  access_mode?: ProjectAccessMode
}

const USE_CASE_PROJECT_ID = 'project-use-case'

export const getProjectAccessMode = (
  project: ProjectAccessFields | null | undefined,
): ProjectAccessMode => {
  if (!project) return 'editable'
  if (project.accessMode) return project.accessMode
  if (project.isDemoTemplate || project.id === USE_CASE_PROJECT_ID) {
    return 'readOnlyTemplate'
  }
  return 'editable'
}

export const isProjectReadOnlyTemplate = (
  project: ProjectAccessFields | null | undefined,
): boolean => getProjectAccessMode(project) !== 'editable'

export const normalizeProjectAccessMetadata = <
  T extends ProjectAccessFields,
>(project: T): T => {
  const apiProject = project as T & ProjectApiAccessFields
  const normalized = {
    ...project,
    isDemoTemplate: project.isDemoTemplate ?? apiProject.is_demo_template,
    accessMode: project.accessMode ?? apiProject.access_mode,
  }

  return {
    ...normalized,
    accessMode: getProjectAccessMode(normalized),
  } as T
}
